import { Component } from 'react'

import * as React from 'react'
import { DataGrid } from 'app/components';
import { GIVTableDataSource } from 'app/containers/Home/DataSources';

export class GivIndexTable extends Component<{}, {}> {
  public round(numberToRound: number, precision: number) {
    return (Math.round(numberToRound * 10) / 10).toFixed(precision)
  }

  render() {
    return (
      <section>
        <header style={{ padding: "1rem" }}>Performance by Calendar Year</header>
        <DataGrid DataSource={GIVTableDataSource}
          pageSizes={[10, 15]}
          hideInputs={true}
          columns={[
            { label: 'Year', pathExpression: '$.year', customRender: (data) => (<span>{data.year.toString()}</span>) },
            { label: 'GIV Index', pathExpression: '$.give', customRender: (data) => (<span>{this.round(data.give, 1) + '%'}</span>) },
            {
              label: '60 / 40 Index', pathExpression: '$.sixtyForty', customRender: (data) => (<span>{this.round(data.sixtyForty, 1) + '%'}</span>)
            },
            {
              label: 'Fixed Income', pathExpression: '$.barclay', customRender: (data) => (<span>{this.round(data.barclay, 1) + '%'}</span>)
            },
            {
              label: 'Equities', pathExpression: '$.spFiveHundred', customRender: (data) => (<span>{this.round(data.spFiveHundred, 1) + '%'}</span>)
            }]}>
        </DataGrid>
      </section>
    )
  }
}


// WEBPACK FOOTER //
// ./src/app/components/visualizations/GivIndexTable/index.tsx